import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeTargetPopup } from 'modules/popup/actions';
import app from 'new-ui/app';
import { GA_GENERAL_CATEGORY, GA_GENERAL_EVENTS, GA_GENERAL_POPUPS_SOURCES } from 'modules/ga/generalEvents';
import { PopupVersion } from './PopupVersion';

const sendPopupOpenGAEvent = (type) => (
  app.sendGoogleAnalyticsEvent(
    GA_GENERAL_CATEGORY,
    GA_GENERAL_EVENTS.POPUP_OPEN,
    { popup: type, source: GA_GENERAL_POPUPS_SOURCES.DASHBOARD },
  )
);

export const Popups = () => {
  const gaPopupIdsSetRef = useRef(new Set());
  const dispatch = useDispatch();
  const popups = useSelector((state) => state.popup);

  const { type: popupType, id: popupId } = popups.at(-1) ?? {};

  useEffect(() => {
    if (popupType && !gaPopupIdsSetRef.current.has(popupId)) {
      gaPopupIdsSetRef.current.add(popupId);
      sendPopupOpenGAEvent(popupType);
    }
  }, [popupId, popupType]);

  return (
    <div className="popups">
      {popups.map((popupEntry, index) => (
        <PopupVersion
          key={index}
          isMain={index === 0}
          isTop={index + 1 === popups.length}
          zIndex={index + 1}
          closePopup={() => {
            dispatch(closeTargetPopup(index));
          }}
          popupEntry={popupEntry || null}
        />
      ))}
    </div>
  );
};
